<template>
  <b-modal
    v-model="isOpen"
    centered
    @hide="closeModal"
    hide-footer
    class="otp-modal md"
    id="otp-verification-modal"
    @hidden="$emit('close')"
  >
    <!-- <template #modal-header>
      <div class="otp-modal-header">
        <b-button variant="close-btn" class="btn-container" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template> -->

    <b-container class="otp-modal-container">
      <div class="otp-modal-content">
        <h6>Verify OTP</h6>
        <p class="text-muted mb-2">
          An OTP has been sent to your {{ identifierTypeText }}:
          <br />
          <strong style="word-wrap: break-word">{{ identifier }}</strong>
        </p>

        <label class="mb-2">Enter the 6-digit OTP below:</label>

        <div class="d-flex otp-inputs-wrapper">
          <input
            v-for="(digit, index) in otpDigits"
            :key="index"
            v-model="otpDigits[index]"
            ref="otpInputs"
            type="text"
            maxlength="1"
            class="form-control otp-input"
            @input="handleOtpInput(index, $event)"
            @keydown.delete="handleOtpDelete(index, $event)"
            @keydown="preventNonNumeric($event)"
            @paste="handlePaste($event)"
            inputmode="numeric"
            pattern="\d*"
            :disabled="otpVerified || !enableVerifyandOtp"
          />
        </div>

        <b-button
          class="verify-btn univ-btn"
          :disabled="
            !isOtpComplete || otpVerified || otpVerificationInProgress || !enableVerifyandOtp
          "
          @click="verifyOtp"
        >
          <span v-if="otpVerificationInProgress">Verifying...</span>
          <span v-else-if="otpVerified">Verified</span>
          <span v-else>Verify OTP</span>
        </b-button>

        <div
          v-if="otpValidationMessage?.message && otpAttempted && !skipVerification"
          class="otp-message-container mt-2 form-group"
        >
          <div :class="['validate-message', otpValidationMessage.type]">
            <div :class="['message-indicator', `${otpValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${otpValidationMessage.type}-text`">
                {{ otpValidationMessage.title }}
              </strong>
              -
              {{ otpValidationMessage.message }}
            </span>
          </div>
        </div>

        <div class="mb-3">
          <div v-if="showResendOTPButton" class="resendOTP">
            <a href="#" class="resend" @click.prevent="resendOTP">
              <span v-if="resendOTPInProgress">sending</span>
              <span v-else>Resend OTP</span>
            </a>
          </div>
          <OTPTimer
            v-if="showTimerContent"
            @sendOTP="setresendOTP"
            :expirySecond="600"
            :setSpinnerLoader="otpLoader"
            @timerFinished="setresendOTP"
            ref="otpTimer"
          />
        </div>
        <!-- <div class="d-flex justify-content-center mt-3 mb-2">
            <a href="#" class="cancel-btn-v2" @click="closeModal">Cancel</a>
        </div> -->
        <div class="modal-action-btns d-flex justify-content-between flex-wrap">
          <b-button class="btn cancel-btn w-100 w-md-45" @click="closeModal">Cancel</b-button>

          <b-button
            class="univ-btn w-100 w-md-45 m-0"
            :disabled="!canSaveChanges"
            @click="saveChanges"
          >
            Save changes
          </b-button>
        </div>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
  import OTPTimer from './RegistrationOtpTimer.vue';
  import axios from '@/utils/regAxios';
  import Cookies from 'js-cookie';

  export default {
    name: 'OtpVerificationModal',
    components: {
      OTPTimer,
    },
    props: {
      identifier: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        default: 'email', // "email" or "phone"
        validator: (value) => ['email', 'phone'].includes(value),
      },
      value: {
        type: Boolean,
        required: true,
      },
      identifierTypeText: {
        type: String,
        default: 'email',
      },

      field: {
        type: String,
      },
    },

    data() {
      return {
        otpDigits: Array(6).fill(''),
        otpVerified: false,
        skipVerification: false,
        otpValidationMessage: {},
        otpAttempted: false,
        otpVerificationInProgress: false,
        skipValidationMessage: null,
        validationStatus: null,
        validationInProgress: false,
        showResendOTPButton: false,
        resendOTPInProgress: false,
        enableVerifyandOtp: true,
        showTimerContent: true,
      };
    },

    computed: {
      isOpen: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },
      isOtpComplete() {
        return this.otpDigits.every((d) => d !== '');
      },

      otpCode() {
        return this.otpDigits.join('');
      },
    },
    methods: {
      removeTimer() {
        Cookies.remove('otp_logged_time');
      },

      setresendOTP() {
        this.showResendOTPButton = true;
      },

      saveChanges() {
        if (this.otpVerified) {
          this.$emit('save', {
            field: this.field,
            verified: true,
            skipped: false,
            identifier: this.identifier,
            type: this.identifierTypeText,
          });
          this.showTimerContent = false;
          this.removeTimer();
          this.closeModal();
        } else if (this.skipVerification) {
          this.$emit('save', {
            field: this.field,
            verified: false,
            skipped: true,
            identifier: this.identifier,
            type: this.identifierTypeText,
          });
          this.closeModal();
        } else {
          this.skipValidationMessage = {
            type: 'error',
            title: 'Error',
            message: 'Please verify the OTP or skip verification.',
          };
        }
      },

      closeModal() {
        this.$emit('close');
        this.resetValidationState();
      },

      handleOtpInput(index, event) {
        // Sanitize input to numbers only
        const sanitizedValue = event.target.value.replace(/\D/g, '');
        this.otpDigits[index] = sanitizedValue;

        // Ensure only one digit is entered
        if (event.target.value.length > 1) {
          this.otpDigits[index] = event.target.value.slice(0, 1);
          return;
        }

        // Move to next input when a digit is entered
        if (sanitizedValue && index < 5) {
          this.$nextTick(() => {
            this.$refs.otpInputs[index + 1].focus();
          });
        }

        // Emit complete event if all digits filled
        if (this.otpDigits.every((d) => d) && index === 5) {
          this.$emit('complete', this.otpDigits.join(''));
        }
      },

      handleOtpDelete(index, event) {
        // Move to previous input when backspace is pressed on an empty field
        if (!event.target.value && index > 0) {
          this.$nextTick(() => {
            this.$refs.otpInputs[index - 1].focus();
          });
        }
      },
      preventNonNumeric(event) {
        // Allow: backspace, delete, tab, escape, enter
        if (
          [8, 9, 13, 27, 46].includes(event.keyCode) ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (event.ctrlKey && [65, 67, 86, 88].includes(event.keyCode)) ||
          // Allow: left/right arrows
          (event.keyCode >= 37 && event.keyCode <= 40)
        ) {
          return;
        }

        // Block non-numeric keys
        if (
          (event.keyCode < 48 || event.keyCode > 57) && // 0-9
          (event.keyCode < 96 || event.keyCode > 105) // Numpad 0-9
        ) {
          event.preventDefault();
        }
      },
      handlePaste(event) {
        event.preventDefault();

        const pastedText = (event.clipboardData || window.clipboardData).getData('text');

        const numericText = pastedText.replace(/[^0-9]/g, '');

        const otpText = numericText.slice(0, 6);

        this.fillOtpInputs(otpText);
      },
      fillOtpInputs(otpText) {
        this.otpDigits = Array(6).fill('');

        for (let i = 0; i < Math.min(otpText.length, 6); i++) {
          this.otpDigits[i] = otpText[i];
        }

        const focusIndex = Math.min(otpText.length, 5);
        this.$nextTick(() => {
          if (this.$refs.otpInputs && this.$refs.otpInputs[focusIndex]) {
            this.$refs.otpInputs[focusIndex].focus();
          }
        });
      },

      // method to handle the OTP verification
      async verifyOtp() {
        this.otpVerificationInProgress = true;
        this.otpAttempted = true;

        try {
          const url = process.env.VUE_APP_API_URL_V2 + 'verify-group-otp';
          console.log('Making POST request to:', url); // Debug log

          const response = await axios.post(
            url,
            {
              contact: this.identifier,
              enrollment_id: this.$store.getters.regTempId,
              type: this.identifierTypeText === 'email' ? 'email' : 'phone',
              otp: this.otpDigits.join(''),
            },
            {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
            },
          );

          console.log('API Response:', response.data); // Debug log

          if (
            response.data.success === true ||
            response.data.status === 'success' ||
            response.data.verified === true
          ) {
            this.otpVerified = true;
            this.skipVerification = false;
            this.otpValidationMessage = {
              type: 'success',
              title: 'OTP Verified',
              message: 'Your OTP has been successfully verified.',
            };
            this.$notify('OTP verified successfully!');
            this.canSaveChanges = true; // Enable save changes button
            this.removeTimer();
            this.showTimerContent = false;
          } else {
            this.otpVerified = false;
            this.otpValidationMessage = {
              type: 'error',
              title: 'OTP Verification Failed',
              message: response.data.message || 'Invalid OTP. Please try again.',
            };
          }
        } catch (error) {
          console.error('OTP verification error:', error);
          this.otpVerified = false;

          if (error.response?.data?.message.includes('Invalid OTP')) {
            this.$notify('Invalid OTP. Please try again.', 'error');

            this.otpValidationMessage = {
              type: 'error',
              title: 'Verification Error',
              message: ' Invalid OTP. Please try again.',
            };
          } else if(error.response?.data?.message.includes('OTP has expired')) {
            this.$notify('The OTP has expired. Please resend the OTP and try again', 'error');
            this.otpValidationMessage = {
              type: 'error',
              title: 'Verification Error',
              message: 'The OTP has expired. Please resend the OTP and try again.',
            };
          }
          else  {
            this.$notify('Something went wrong. Please try again.', 'error');
            this.otpValidationMessage = {
              type: 'error',
              title: 'Verification Error',
              message: 'failed to verify OTP. Please try again later.',
            };
          }
        } finally {
          this.otpVerificationInProgress = false;
        }
      },

      canSaveChanges() {
        if (this.loading) return false;

        if (this.otpVerified) {
          return true;
        } else if (this.skipVerification) {
          return true;
        } else if (this.validationStatus && this.validationStatus.type === 'error') {
          return false;
        } else {
          return false;
        }
      },

      // method to send the otp
      async resendOTP() {
        this.$refs.otpTimer.sendOtpCode();
        this.showResendOTPButton = false;
        this.resendOTPInProgress = true;
        try {
          let url = process.env.VUE_APP_API_URL_V2 + `send-group-otp`;
          axios
            .post(url, {
              contact: this.identifier,
              enrollment_id: this.$store.getters.regTempId,

              type: this.identifierTypeText,
            })

            .then((res) => {
              if (res.data.success === true || res.data.status === 'success') {
                this.$notify('OTP sent successfully!');

                this.resendOTPInProgress = false;
                this.otpDigits = Array(6).fill(''); // Clear the OTP input fields
                this.otpValidationMessage = null;
              } else {
                this.$notify(res.data.message || 'Failed to send OTP. Please try again.', 'error');
                // this.showOtpSection = false;
              }
            })

            .catch((err) => {
              this.$notify(err.response.data.message, 'error');
            });
        } catch (error) {
          this.$notify('Failed to send OTP. Please try again.', 'error');
          // this.showOtpSection = false;
          console.error('OTP send error:', error);
        }
      },

      // emitVerification() {
      //   this.$emit("verify", this.otpCode);
      //   this.closeModal();
      // },

      // handleResendOtp() {
      //   console.log("Resending OTP...");
      //   this.$emit('resend-otp');
      // }
    },
  };
</script>
<style>
  #otp-verification-modal .resend-otp {
    margin-top: 0;
  }
  #otp-verification-modal .modal-header .close {
    height: 55px;
    aspect-ratio: 1 / 1;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    right: -1%;
    top: -1%;
    opacity: 1;
    text-align: center;
    line-height: 44px;
    font-size: 24px;
    border: none;
    cursor: pointer;
    padding: 0;
    font-family: inherit;
    font-weight: bold;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    
  }
  #otp-verification-modal .modal-header .close:focus,
  #otp-verification-modal .modal-header .close:hover {
    opacity: 100% !important;
    scale: 108%;
  }
</style>
<style scoped>
  ::v-deep(.modal-header) {
    border-bottom: none;
  }
  #otp-verification-modal .modal-header {
    border-bottom: none;
    padding: 0;
  }
  .otp-modal-container {
    padding: 0 6px;
  }
  .otp-modal .modal-content {
    border-radius: 10px;
    padding: 1.5rem;
  }
  .otp-modal-content p,
  .otp-modal-content label {
    font-size: 0.875rem;
  }
  .otp-inputs-wrapper {
    display: flex;
    margin-top: 0.5rem;
    gap: 1rem;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 1rem;
  }
  .otp-inputs-wrapper .otp-input {
    height: 100%;
    aspect-ratio: 1/1;
    width: 100%;
    /* max-width: 55px; */
    text-align: center;
    font-size: 1.25rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
  }
  .otp-inputs-wrapper .otp-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  .verify-btn {
    /* border-color: #03c3ec;
        background-color: #E0F8FD !important;
        color: #fff; */
    width: 100%;
    max-width: none;
    margin-bottom: 0.75rem;
    margin-top: 0rem;
  }
  .verify-btn:focus {
    max-width: none;
  }
  .cancel-btn {
    border-radius: 6px;
    color: #fff;
    background: #6c757d !important;
    outline: none;
    border: 0;
    text-align: center;
    padding: 10px;
    transition: all ease 0.6s;
  }
  .cancel-btn-v2 {
    color: #2c3f58;
    font-size: 14px;
  }
  .cancel-btn-v2:hover {
    color: #03c3ec;
  }
  .modal-action-btns .univ-btn {
    max-width: 100%;
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  /* .modal-action-btns {
        gap: 0.75rem;
    } */
  @media (min-width: 577px) {
    .w-md-45 {
      max-width: 48% !important;
    }
  }
  @media (max-width: 576px) {
    ::v-deep(.modal-header .close) {
      height: 55px;
    }
    .otp-inputs-wrapper {
      margin-bottom: 0.75rem;
      gap: 0.75rem;
    }
    .otp-input {
      min-width: 0;

      font-size: 1.2rem;
    }
    .verify-btn {
      min-width: 100%;
      margin-bottom: 0.5rem;
    }
    .modal-action-btns {
      flex-direction: column;
      gap: 0.5rem;
    }
    .univ-btn {
      max-width: none;
      width: 100%;
    }
  }
  @media (max-width: 425px) {
    .otp-inputs-wrapper {
      gap: 0.5rem;
    }
  }
</style>
